var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.4998L4.91355 12.9133H2.34375C1.05141 12.9133 0 11.8619 0 10.5696V2.84399C0 1.55165 1.05141 0.500244 2.34375 0.500244H12.6562C13.9486 0.500244 15 1.55165 15 2.84399V10.5696C15 11.8619 13.9486 12.9133 12.6562 12.9133H10.0864L7.5 15.4998ZM2.34375 1.67212C1.69758 1.67212 1.17188 2.19782 1.17188 2.84399V10.5696C1.17188 11.2158 1.69758 11.7415 2.34375 11.7415H5.39895L7.5 13.8425L9.60106 11.7415H12.6562C13.3024 11.7415 13.8281 11.2158 13.8281 10.5696V2.84399C13.8281 2.19782 13.3024 1.67212 12.6562 1.67212H2.34375ZM8.08594 10.4612H6.91406V9.28931H8.08594V10.4612ZM8.08594 8.11743H6.91406V7.23844C6.91406 6.5782 7.28821 5.98201 7.89047 5.68254C8.1999 5.52867 8.39139 5.20576 8.37823 4.85991C8.36092 4.40429 7.99046 4.03383 7.53483 4.01651C7.29278 4.00723 7.06415 4.09433 6.89054 4.26147C6.71678 4.42875 6.62109 4.65366 6.62109 4.89475H5.44922C5.44922 4.33219 5.67246 3.80748 6.07778 3.41725C6.48299 3.02716 7.01605 2.8239 7.57931 2.84549C8.64355 2.88589 9.50886 3.7512 9.54926 4.81544C9.57984 5.62093 9.13354 6.37313 8.41225 6.73184C8.21098 6.83191 8.08594 7.02604 8.08594 7.23844V8.11743Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentcolor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuaries);
export default __webpack_public_path__ + "static/media/quaries.e9ded1189f922a6065bcfd3ad067acc2.svg";
export { ForwardRef as ReactComponent };